import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";

import LocationLinkMarkerItem
  from 'components/dashboard/location-links-content/LocationLinkMarkerItem';
import AddLocationMarkerForm
  from 'components/dashboard/location-links-content/AddLocationMarkerForm';
import ProLabel from 'components/common/ProLabel';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';
import CommonMessage from 'components/common/CommonMessage';

import './LocationLinkMarkers.css';


function LocationLinkMarkers(props) {
  const { me, linkItem, createLocationMarkerSuccess } = props;
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (createLocationMarkerSuccess) {
      setShowForm(false);
    }
  }, [createLocationMarkerSuccess]);

  const locked = me && me.subscription && !me.subscription.ff_maps;
  const placeholderContent = (
    <div>{t("This option is available on the PRO plan.")}</div>
  );

  return (
    <div className="location-link-markers__component">
      <div className="title">{t("Markers on the map")}</div>

      <div className="markers-container">
        {linkItem.markers.map(marker => (
          <LocationLinkMarkerItem
            key={`location-link-marker-item-${linkItem.id}-${marker.id}`}
            marker={marker}
            linkItem={linkItem}
          />
        ))}
      </div>

      {showForm &&
        <div className="add-marker-form-container">
          <AddLocationMarkerForm
            key={`add-location-marker-form-${linkItem.id}`}
            linkItem={linkItem}
          />
        </div>
      }

      {linkItem.markers && linkItem.markers.length < 20 && !showForm &&
        <ProFeaturePlaceholder
          noKeyIcon
          locked={locked}
          placeholderContent={placeholderContent}
        >
          <div
            className="add-marker-button"
            onClick={() => setShowForm(true)}
            role="button"
            tabIndex={-1}
          >
            <div className="add-icon" />
            <div className="text">{t("Add another marker")}</div>
            <ProLabel />
          </div>
        </ProFeaturePlaceholder>
      }

      {linkItem.markers && linkItem.markers.length === 20 &&
        <CommonMessage warning>{t("You can create only 20 markers")}</CommonMessage>
      }
    </div>
  );
}

LocationLinkMarkers.propTypes = {
  linkItem: PropTypes.object.isRequired,
  createLocationMarkerSuccess: PropTypes.object,
  me: PropTypes.object,
};

LocationLinkMarkers.defaultProps = {
  createLocationMarkerSuccess: null,
  me: null,
};

const mapStateToProps = state => (
  {
    createLocationMarkerSuccess: state.locationLinksReducer.createLocationMarkerSuccess,
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {},
)(LocationLinkMarkers);
